module.exports = __webpack_public_path__ + "1c33bf784adbece083fcdcd1ce301ad3.svg";